import { ReduxAction } from 'actions';
import { ToastType } from '@components/Toast/Toast';
import {
    ToastActionType,
    ToastAction,
    RemoveToastActionType,
} from '@actions/toastActions';

export type ToastsReducer = ToastType[];

const initialState: ToastsReducer = [];

export default function (state: ToastsReducer = initialState, action: ReduxAction) {
    switch (action.type) {
        case ToastActionType.addToast:
            return [...state, (action as ToastAction).toast];
        case ToastActionType.removeToast:
            const newState = [...state];
            const removeToastAction = (action as RemoveToastActionType);
            const index = newState.findIndex(t => t.id === removeToastAction.toast.id);
            if (index > -1) {
                newState.splice(index, 1);
            }
            return newState;
        default:
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/toastsReducer.ts